import { useEffect, useRef, useState } from 'react';

/**
 * Formatta i secondi in mm:ss (o hh:mm:ss oltre l'ora).
 */
export const formatCallDuration = (totalSeconds) => {
  const seconds = Math.max(0, Math.floor(totalSeconds || 0));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n) => n.toString().padStart(2, '0');
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};

/**
 * Timer della durata chiamata: parte quando `running` diventa true e si azzera
 * quando torna false. Ritorna i secondi trascorsi.
 */
export const useCallDuration = (running = true, onStart, onStop) => {
  const [seconds, setSeconds] = useState(0);
  const timerRef = useRef(null);
  const startedAtRef = useRef(null);

  useEffect(() => {
    if (running) {
      startedAtRef.current = Date.now();
      setSeconds(0);
      if (onStart) onStart();
      timerRef.current = setInterval(() => {
        setSeconds(Math.floor((Date.now() - startedAtRef.current) / 1000));
      }, 1000);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      if (onStop) onStop();
      startedAtRef.current = null;
      setSeconds(0);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [running, onStart, onStop]);

  return seconds;
};

export default useCallDuration;
